import React from "react";
import { Row, Col, Form, Button, Dropdown, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Search, KeyboardArrowDown, MoreHoriz } from "@material-ui/icons";
import axios from "axios";
import UrlConstants from "../../config/UrlConstants";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import {
  registrationRequestsAction,
  activeUserAction,
  removeRegistartionAction,
  rejectRegistartionAction,
  rejectRegistartionsListAction,
  activateAccOwnerAction,
} from "./../../actions/UserActions";

import noRecord from "./../../assets/img/no-record.png";
import PhoneNumber from "../Common/phoneNumber";
import DeletePrompt from "../Common/DeletePrompt";
import * as code from "./../../config/Constants";
import AssignPlanForm from "./../BillingModule/BillingPlans/AssignPlanForm";
import { createOrUpdateInvoiceAction } from "./../../actions/BillingActions";
import * as message from "./../../config/CommonMessages";
import { toastMessage, checkObjExists } from "./../Common/Common";

class RegistrationRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      status: null,
      UserMessage: "",
      searchParam: "",
      toggleActive: "",
      showDelete: "Registration Requests",
      users: [],
      showLoader: true,
      modalUserData: {},
      modalCmpnyData: {},
      recordPerPage: code.RECORD_PER_PAGE,
      lastSyncTimestamp: "",
      showRejections: false,
      filterData: [],
      rejectedUsers: [],
      searchedRequests: [],
      originalRequestsUsers: [],
      filteredRequestsUsers: [],
      btnName: "Rejected Requests",
      isHideSts: true,
      deletePrompt: false,
      requestId: "",
      page: 0,
      activateUserId: "",
      billingPlanPrompt: false,
    };

    this.removeRegistration = this.removeRegistration.bind(this);
    this.assignPlan = this.assignPlan.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Studio Name",
      selector: "company",
      sortable: true,
    },
    {
      name: "Mobile No.",
      selector: "mobile",
     // sortable: true,
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
    },
    {
      name: "Referral Code",
      selector: "referralCode",
      sortable: true,
    },
    {
      name: "",
      selector: "active",
      sortable: true,
      width: "105px",
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "reject",
      sortable: true,
      width: "105px",
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "action",
      width: "60px",
      right: true,
      ignoreRowClick: true,
    },
  ];

  setUserDataModal(user, cmpny) {
    this.setState({ modalUserData: user, modalCmpnyData: cmpny });
  }

  toggleActive() {
    if (this.state.toggleActive == "active") {
      this.setState({ toggleActive: "" });
    } else {
      this.setState({ toggleActive: "active" });
    }
  }

  componentWillMount() {
    this.getRequestedUser(this.state.page);
  }
  getRequestedUser(pageIndex) {
    this.props
      .registrationRequestsAction(
        this.state.recordPerPage,
        this.state.lastSyncTimestamp,
        pageIndex
      )
      .then((res) => {
        this.setState({
          users: this.props.users || [],
          originalRequestsUsers: this.props.users || [],
          filteredRequestsUsers: this.props.users || [],
          showRejections: false,
          showLoader: false,
          showDelete: "Registration Requests",
          btnName: "Rejected Requests",
        });
      });
  }

  /**
   * @desc get list of rejected registration requests
   * @param {*} flag
   */
  getRejectedUsers(flag, pageIndex) {
    this.setState({ status: false, showLoader: true });
    if (!this.state.showRejections || flag) {
      this.props
        .rejectRegistartionsListAction(this.state.recordPerPage, pageIndex)
        .then((res) => {
          setTimeout(
            function() {
              this.setState({
                status: null,
                UserMessage: null,
              });
            }.bind(this),
            3000
          );
          this.setState({
            searchParam: "",
            showRejections: true,
            showLoader: false,
            showDelete: "Rejected Requests",
            users: res.data.data,
            originalRequestsUsers: res.data.data || [],
            filteredRequestsUsers: res.data.data || [],
            btnName: "Registration Requests",
            status: null,
            UserMessage: null,
          });
        });
    } else {
      this.setState({
        showRejections: false,
        showLoader: false,
        showDelete: "Registration Requests",
        btnName: "Rejected Requests",
      });
      this.getRequestedUser(this.state.page);
    }
  }

  /**
   * @desc search request based on input data
   * @param {*} param
   */
  search(param) {
    param = param.trim();
    var requests = [];
    requests = this.state.filteredRequestsUsers.filter((o) => {
      var found = false;
      Object.keys(o).forEach((v) => {
        if (
          v == "firstname" ||
          v == "lastname" ||
          v == "mobileNumber" ||
          v == "brokerLicenseNo"
        ) {
          let item = o[v] + "";
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        } else if (v == "email") {
          let item = o[v].address + "";
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        }
      });
      return found;
    });
    this.setState({
      users: requests,
      searchParam: param,
      isSearched: param.trim() == "" ? false : true,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  /**
   * @desc api call for active/accept registration request by user Id
   * @param {*} uId
   */
  activeUserAction(userId) {
    this.setState({ showLoader: true });
    this.props.activeUserAction(userId).then((res) => {
      if (this.state.showRejections) {
        this.getRejectedUsers(this.state.showRejections, this.state.page);
        this.setState({ isHideSts: false });
      } else {
        this.props
          .registrationRequestsAction(
            this.state.recordPerPage,
            this.state.lastSyncTimestamp,
            this.state.page
          )
          .then((res) => {
            this.setState({ isHideSts: false });
          });
      }

      this.setState({ showLoader: false });
    });

    this.setState({
      status: null,
      UserMessage: null,
    });
    setTimeout(
      function() {
        this.setState({
          isHideSts: true,
        });
      }.bind(this)
    );
  }

  changePage = async (page) => {
    this.state.btnName === "Rejected Requests"
      ? this.getRequestedUser(page - 1)
      : this.getRejectedUsers(true, page - 1);
  };

  /**
   * @desc api call for remove/delete registration request by user Id
   * @param {*} uId
   */
  removeRegistration(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.removeRegistartionAction(uId).then((res) => {
      if (this.props.status) {
        this.setState({
          status: null,
          UserMessage: null,
        });

        if (this.state.showRejections) {
          this.getRejectedUsers(true, this.state.page);
        } else {
          this.props
            .registrationRequestsAction(
              this.state.recordPerPage,
              this.state.lastSyncTimestamp,
              this.state.page
            )
            .then((res) => {
              this.setState({ isHideSts: false });
            });
        }
        this.setState({ showLoader: false });

        setTimeout(
          function() {
            this.setState({
              isHideSts: true,
            });
          }.bind(this),
          3000
        );
      }
    });
  }

  /**
   * @desc api call for reject registration request by user Id
   * @param {*} uId
   */
  rejectRegistration(uId) {
    this.setState({ showLoader: true });
    this.props.rejectRegistartionAction(uId).then((res) => {
      if (this.props.status) {
        this.setState({
          status: null,
          UserMessage: null,
        });

        this.props
          .registrationRequestsAction(
            this.state.recordPerPage,
            this.state.lastSyncTimestamp,
            this.state.page
          )
          .then((res) => {
            this.setState({ isHideSts: false });
          });
      }
      this.setState({ showLoader: false });
      setTimeout(
        function() {
          this.setState({
            isHideSts: true,
          });
        }.bind(this),
        3000
      );
    });
  }

  async updatedb() {
    // console.log("i am here");
    var accessToken = localStorage.getItem("accessToken");
    const headersSet = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth-token": accessToken,
    };
    let formData = { hello: "hello" };
    const response = await axios.post(
      `${UrlConstants.addContact}/updateauthdb`,
      formData,
      {
        headers: headersSet,
      }
    );
    // console.log("reponse");
  }

  /**
   * @desc open delete promt
   * @param {*} id
   */
  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      requestId: id,
    });
  }

  openActivateModal(id) {
    this.setState({
      //showActivateModal: true,
      billingPlanPrompt: !this.state.billingPlanPrompt,
      activateUserId: id,
    });
  }

  assignPlan(data) {
    //console.log("register assignPlan data", data);
    this.setState({
      showLoader: true,
    });
    let postData = {
      userId: this.state.activateUserId ? this.state.activateUserId : "",
      planId: data && data.selectedPlanId ? data.selectedPlanId : "",
      startDate: data && data.startDate ? new Date(data.startDate) : "",
      endDate: data && data.endDate ? new Date(data.endDate) : "",
    };
    //console.log("register assignPlan postData", postData);
    this.props.activateAccOwnerAction(postData).then((res) => {
      if (res.status === code.OK) {
        if (this.state.showRejections) {
          this.getRejectedUsers(this.state.showRejections, this.state.page);
          this.setState({ isHideSts: false });
        } else {
          this.props
            .registrationRequestsAction(
              this.state.recordPerPage,
              this.state.lastSyncTimestamp,
              this.state.page
            )
            .then((res) => {
              this.setState({ isHideSts: false });
            });
        }

        this.setState({
          showLoader: false,
          billingPlanPrompt: false,
        });
        //create invoice
        this.createOrUpdateInvoice(data);
      } else {
        this.setState({
          showLoader: false,
          billingPlanPrompt: false,
        });
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      }
    });

    this.setState({
      status: null,
      UserMessage: null,
    });
    setTimeout(
      function() {
        this.setState({
          isHideSts: true,
        });
      }.bind(this),
      3000
    );
  }

  createOrUpdateInvoice(data) {
    this.setState({
      showLoader: true,
    });
    let postData = {
      userId: this.state.activateUserId ? this.state.activateUserId : "",
      planId: data && data.selectedPlanId ? data.selectedPlanId : "",
    };
    this.props
      .createOrUpdateInvoiceAction(postData)
      .then((res) => {
        this.setState({
          showLoader: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.users.length; i < len; i++) {
      let user = this.state.users[i];
      let accOwnerDsdObj = {};
      if (user.dsd && user.dsd.roles && user.dsd.roles.length > 0) {
        var foundRec = user.dsd.roles.find((x) => x.roleId === "ACCOWNER");
        accOwnerDsdObj = foundRec ? foundRec : {};
      }

      let data = {
        id: user._id,
        name: (
          <Link to={"/UserProfile/" + user._id} className="p-0 text-capitalize">
            {user.firstname} {user.lastname}
          </Link>
        ),
        referralCode:
          checkObjExists(accOwnerDsdObj) && accOwnerDsdObj.referralCode
            ? accOwnerDsdObj.referralCode
            : "",
        company:
          checkObjExists(accOwnerDsdObj) &&
          checkObjExists(accOwnerDsdObj.companyInformation) &&
          accOwnerDsdObj.companyInformation.name
            ? accOwnerDsdObj.companyInformation.name
            : "",
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
        active: (
          <Button
            variant="primary"
            className={"btn-blue btn-grid "}
            onClick={() => this.openActivateModal(user._id)}
          >
            Activate
          </Button>
        ),
        reject: (
          <Button
            variant="transparent"
            className={"btn-blue btn-outlined btn-grid "}
            onClick={() => this.rejectRegistration(user._id)}
          >
            Reject
          </Button>
        ),
        action: (
          <Dropdown alignRight className="dropdown-action">
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-folder1"
              className="p-0"
            >
              <MoreHoriz />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.openDeletePrompt(user._id);
                }}
              >
                Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      };
      if (this.state.showRejections) {
        delete data["reject"];
        delete data["active"];
      }

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">{this.state.showDelete}</h4>
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                  this.setState({ searchParam: e.target.value });
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
          {/* <Col>
            <Button
              variant="primary"
              className={"btn-blue btn-blue btn-head w-140"}
              onClick={this.updatedb}
            >
              Update_auth_db
            </Button>
          </Col> */}
          <Col className="col-auto pl-0">
            <Button
              variant="primary"
              className={"btn-blue btn-blue btn-head w-140"}
              onClick={() =>
                this.state.btnName === "Rejected Requests"
                  ? this.getRejectedUsers(true, this.state.page)
                  : this.getRequestedUser(this.state.page)
              }
            >
              {this.state.btnName}
            </Button>
          </Col>

          <Col className="col-auto pl-0">
            <Button
              variant="primary"
              className={"btn-blue btn-blue btn-head w-140"}
              onClick={() => this.props.history.push("/PendingProfiles")}
            >
              Pending Profiles
            </Button>
          </Col>
        </Row>

        {!this.state.isHideSts && (
          <>
            {this.props.UserMessage && this.state.status !== null && (
              <Alert variant={this.state.status ? "success" : "danger"}>
                {this.state.UserMessage}
              </Alert>
            )}
          </>
        )}
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              highlightOnHover={true}
              className="rdt-requests"
              onRowSelected={this.getSelectedRows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Requests Found</p>
                  </div>
                </div>
              }
              pagination={true}
              paginationServer={true}
              paginationTotalRows={
                this.state.btnName === "Rejected Requests"
                  ? this.props.totalUsers
                  : this.props.totalRejectedUsers
              }
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.requestId}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.removeRegistration}
            />

            <AssignPlanForm
              flag="addPlanActivate"
              billingPlanPrompt={this.state.billingPlanPrompt}
              cancel={() => {
                this.setState({ billingPlanPrompt: false });
              }}
              assignPlan={this.assignPlan}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.reducer.users,
    status: state.reducer.status,
    UserMessage: state.reducer.UserMessage,
    totalUsers: state.reducer.totalUsers,
    totalRejectedUsers: state.reducer.totalRejectedUsers,
  };
};

export default connect(
  mapStateToProps,
  {
    registrationRequestsAction,
    activeUserAction,
    removeRegistartionAction,
    rejectRegistartionAction,
    rejectRegistartionsListAction,
    activateAccOwnerAction,
    createOrUpdateInvoiceAction,
  }
)(RegistrationRequests);
